import clsx from "clsx";
import { IframeProps } from "./Iframe.types";
import { memo } from "react";

/* This component is used to avoid rerendering the Iframe component
 *loading state changes
 */
function InnerIframe({ className, ...rest }: IframeProps) {
    return <iframe title="iframe" sandbox="" className={clsx(className, "iframe")} {...rest} />;
}

export default memo(InnerIframe) as typeof InnerIframe;
